 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ANDE_9781118039977_OEB_COVER_R1 from '@/components/ande_9781118039977_oeb_cover_r1'
 import ANDE_9781118039977_OEB_TOC_R1 from '@/components/ande_9781118039977_oeb_toc_r1'
 import ANDE_9781118039977_OEB_TP_R1 from '@/components/ande_9781118039977_oeb_tp_r1'
 import ANDE_9781118039977_OEB_COP_R1 from '@/components/ande_9781118039977_oeb_cop_r1'
 import ANDE_9781118039977_OEB_PRF_R1 from '@/components/ande_9781118039977_oeb_prf_r1'
 import ANDE_9781118039977_OEB_ACK_R1 from '@/components/ande_9781118039977_oeb_ack_r1'
 import ANDE_9781118039977_OEB_P01_R1 from '@/components/ande_9781118039977_oeb_p01_r1'
 import ANDE_9781118039977_OEB_C01_R1 from '@/components/ande_9781118039977_oeb_c01_r1'
 import ANDE_9781118039977_OEB_C02_R1 from '@/components/ande_9781118039977_oeb_c02_r1'
 import ANDE_9781118039977_OEB_P02_R1 from '@/components/ande_9781118039977_oeb_p02_r1'
 import ANDE_9781118039977_OEB_C03_R1 from '@/components/ande_9781118039977_oeb_c03_r1'
 import ANDE_9781118039977_OEB_C04_R1 from '@/components/ande_9781118039977_oeb_c04_r1'
 import ANDE_9781118039977_OEB_C05_R1 from '@/components/ande_9781118039977_oeb_c05_r1'
 import ANDE_9781118039977_OEB_C06_R1 from '@/components/ande_9781118039977_oeb_c06_r1'
 import ANDE_9781118039977_OEB_C07_R1 from '@/components/ande_9781118039977_oeb_c07_r1'
 import ANDE_9781118039977_OEB_C08_R1 from '@/components/ande_9781118039977_oeb_c08_r1'
 import ANDE_9781118039977_OEB_P03_R1 from '@/components/ande_9781118039977_oeb_p03_r1'
 import ANDE_9781118039977_OEB_C09_R1 from '@/components/ande_9781118039977_oeb_c09_r1'
 import ANDE_9781118039977_OEB_C10_R1 from '@/components/ande_9781118039977_oeb_c10_r1'
 import ANDE_9781118039977_OEB_C11_R1 from '@/components/ande_9781118039977_oeb_c11_r1'
 import ANDE_9781118039977_OEB_C12_R1 from '@/components/ande_9781118039977_oeb_c12_r1'
 import ANDE_9781118039977_OEB_NTS_R1 from '@/components/ande_9781118039977_oeb_nts_r1'
 import ANDE_9781118039977_OEB_IN1_R1 from '@/components/ande_9781118039977_oeb_in1_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_toc_r1",
 			"name" : "ande_9781118039977_oeb_toc_r1",
 			"component" : ANDE_9781118039977_OEB_TOC_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_tp_r1",
 			"name" : "ande_9781118039977_oeb_tp_r1",
 			"component" : ANDE_9781118039977_OEB_TP_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_cop_r1",
 			"name" : "ande_9781118039977_oeb_cop_r1",
 			"component" : ANDE_9781118039977_OEB_COP_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_prf_r1",
 			"name" : "ande_9781118039977_oeb_prf_r1",
 			"component" : ANDE_9781118039977_OEB_PRF_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_ack_r1",
 			"name" : "ande_9781118039977_oeb_ack_r1",
 			"component" : ANDE_9781118039977_OEB_ACK_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_p01_r1",
 			"name" : "ande_9781118039977_oeb_p01_r1",
 			"component" : ANDE_9781118039977_OEB_P01_R1
 		},
 		{
 			"path" : "/ande_9781118039977_oeb_c01_r1",
 			"name" : "ande_9781118039977_oeb_c01_r1",
 			"component" : ANDE_9781118039977_OEB_C01_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js